import Formsy from 'formsy-react';
import React from 'react';
import { Row, Button, Colors, Column } from 'react-foundation';
import Reveal from 'react-foundation-components/lib/global/reveal';
import { connect } from 'react-redux';
import { CloseModal } from '../layout/close-modal';
import { push } from 'react-router-redux';
import { Input } from 'formsy-react-components';
import { createAccount } from '../../state/create-account/actions';
import { login, loadUser } from '../../state/auth/actions';
import { showCreateAccountModal } from '../../state/create-account/actions';
import { showLoginModal } from '../../state/auth/actions';

const CreateAccount = React.createClass({
  getInitialState() {
    return {
      canSubmit: false
    };
  },

  enableButton() {
    this.setState({
      canSubmit: true
    });
  },

  disableButton() {
    this.setState({
      canSubmit: false
    });
  },

  submit(formData) {
    this.props.onSubmit(formData);
  },

  handleHide() {
    this.props.dispatch(showCreateAccountModal(false));
  },

  goToLogin() {
    this.props.dispatch(showCreateAccountModal(false));
    this.props.dispatch(showLoginModal(true));
  },

  render() {
    return (
      <a
        id="register-link"
        onClick={() => {
          this.props.dispatch(showCreateAccountModal(true));
        }}
      >
        Create account
        <Reveal
          onHide={this.handleHide}
          size="tiny"
          show={this.props.showModal}
        >
          <CloseModal onHide={this.handleHide} />
          <div className="create-account-modal">
            <div className="modal-header">
              <Row>
                <Column small={12} className="text-center">
                  <h3 className="text-primary">
                    <strong>Create Account</strong>
                  </h3>
                </Column>
              </Row>
            </div>
            <hr />
            <div className="modal-form">
              <Formsy.Form
                onValidSubmit={this.submit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
              >
                <Row />
                <Row>
                  <Column small={12} large={8} centerOnLarge>
                    <Input
                      label="Email"
                      type="email"
                      name="email"
                      value=""
                      validations="isEmail"
                      labelClassName="small-12"
                      elementWrapperClassName="small-12"
                      placeholder="Enter your email address..."
                      required
                    />
                  </Column>
                </Row>
                <Column small={12} large={8} centerOnLarge>
                  <Input
                    label="Company Name"
                    type="text"
                    name="name"
                    value=""
                    labelClassName="small-12"
                    elementWrapperClassName="small-12"
                    placeholder="Enter your name..."
                    required
                  />
                </Column>
                <Row>
                  <Column small={12} large={8} centerOnLarge>
                    <Input
                      label="Phone"
                      type="text"
                      name="phone"
                      value=""
                      labelClassName="small-12"
                      elementWrapperClassName="small-12"
                      placeholder="Enter your phone number..."
                      required
                    />
                  </Column>
                </Row>
                <Row>
                  <Column small={12} large={8} centerOnLarge>
                    <Input
                      label="Password"
                      type="password"
                      name="password"
                      value=""
                      labelClassName="small-12"
                      elementWrapperClassName="small-12"
                      placeholder="Enter your password..."
                      required
                    />
                  </Column>
                  <Column small={12} large={8} centerOnLarge>
                    <Input
                      label="Confirm"
                      type="password"
                      name="confirm_password"
                      value=""
                      validations="equalsField:password"
                      validationErrors="Both passwords must match"
                      labelClassName="small-12"
                      elementWrapperClassName="small-12"
                      placeholder="Confirm password..."
                      required
                    />
                  </Column>
                </Row>
                <Row>
                  <Column small={12}>
                    <p className="text-red text-center">{this.props.errors}</p>
                  </Column>
                </Row>
                <Row>
                  <Column small={12} large={8} centerOnLarge>
                    <Button
                      className="signup-button"
                      color={Colors.PRIMARY}
                      type="submit"
                      disabled={!this.state.canSubmit}
                      isExpanded
                    >
                      Sign Up
                    </Button>

                    {!this.state.canSubmit ? (
                      <p className="text-gray">Please fill out all fields.</p>
                    ) : null}
                  </Column>
                </Row>
              </Formsy.Form>
            </div>
          </div>
        </Reveal>
      </a>
    );
  }
});

const mapStateToProps = state => ({
  showModal: state.registration.get('showModal'),
  errors: state.registration.get('errors')
});

const mapDispatchToProps = dispatch => ({
  onSubmit: formData => {
    const signupData = {
      ...formData,
      email: formData.email.toLowerCase()
    };

    dispatch(createAccount(signupData)).then(response => {
      if (response.ok) {
        dispatch(login(signupData.email, signupData.password)).then(
          response => {
            if (response.ok) {
              dispatch(loadUser());
              dispatch(push('/profile'));
            }
          }
        );
      }
    });
  },
  dispatch
});

const CreateAccountModal = connect(mapStateToProps, mapDispatchToProps)(
  CreateAccount
);

export default CreateAccountModal;



/** WEBPACK FOOTER **
 ** ./src/components/create-account/create-account.jsx
 **/